enum TRACK_EVENT_TYPES {
  ACTION = 'click',
}

enum BI_EVENTS {
  SIGNUP_WITH_GOOGLE = 'Signup with google',
  LOGIN = 'Login',
  PRIVACY_POLICY = 'privacy_policy',
  TERMS_OF_SERVICE = 'terms_of_service',
}

const BI_TRACKER = (
  message: BI_EVENTS,
  action: TRACK_EVENT_TYPES,
  props?: Record<string, unknown>,
) => {
  window.rudderanalytics.track(message, { action, ...props });
};

export { TRACK_EVENT_TYPES, BI_EVENTS, BI_TRACKER };
